import { Box } from "@mui/material";
import React from "react";
import "./animate.css";
import { resolveBrand } from "../../branding/brandRegistry";

// Splash de carregamento. Resolve a marca SÓ pelo hostname (síncrono; params ainda não
// existem aqui — este componente renderiza acima do BrandProvider). Só marca com domínio
// dedicado mostra o próprio logo aqui; marca identificada por ?url (ex.: Nave) ou só por
// ?rules cai no default e exibe o logo da Atem no splash (limitação RN06).
const LoadingApp: React.FC = () => {
  const brand = resolveBrand({ host: window.location.hostname });
  const logo = brand.id !== "default" ? brand.assets.logo : "/images/atem-logotipo.png";

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      height={"100vh"}
    >
      <div className={"pulse"}>
        <Box
          component="img"
          src={logo}
          alt={brand.portalName}
          sx={{ maxWidth: 160, maxHeight: 48, width: "auto", height: "auto" }}
        />
      </div>
    </Box>
  );
};

export default LoadingApp;
